import axios from "axios";
import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AsyncSelect from "react-select/async";
import { selcetCustomer } from "../../../features/posSlice";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api/";

const SelectCustomer = (props) => {
  const dispatch = useDispatch();
  const posSaleData = useSelector((state) => state.posReducer);
  const [selectedOption, setSelectedOption] = useState({
    label: posSaleData.customerName,
    option: posSaleData.customerId,
  });

  const selectRef = useRef();

  const fetchData = async (inputValue, callback) => {
    let cancelToken;
    if (typeof cancelToken !== "undefined") {
      cancelToken.cancel("Cancel The Previous Request");
    }

    cancelToken = axios.CancelToken.source();
    try {
      const result = await axios.get(
        `${BASE_URL}customer/search/${props.aamarId}/${inputValue}`,
        {
          cancelToken: cancelToken.token,
        }
      );

      let tempArray = [];
      if (result.data.length > 0) {
        result.data.forEach((element) => {
          tempArray.push({
            label: `${element.name} - [ ${element.phone} ]`,
            value: element._id,
          });
        });
      } else {
        tempArray.push({
          label: posSaleData.customerName,
          option: posSaleData.customerId,
        });
      }

      callback(tempArray);
    } catch (error) {
      console.error("Error fetching customer data:", error);
    }
  };

  const getValue = async (data) => {
    let cancelToken;

    if (typeof cancelToken !== "undefined") {
      cancelToken.cancel("Cancel The Previous Request");
    }

    cancelToken = axios.CancelToken.source();

    try {
      const result = await axios.get(
        `${BASE_URL}customer/select/${props.aamarId}/${data}`,
        {
          cancelToken: cancelToken.token,
        }
      );

      const customerData = {
        customerId: result.data._id,
        point: result.data.point,
        name: result.data.name,
        phone: result.data.phone,
        group: result.data.group,
      };
      dispatch(
        selcetCustomer({
          customerId: result.data._id,
          point: result.data.point,
          name: result.data.name,
          phone: result.data.phone,
          group: result.data.group ? result.data.group : null,
        })
      );
    } catch (error) {
      console.error("Error selecting customer:", error);
    }
  };

  const onSearchChange = (selectedOption) => {
    if (selectedOption) {
      setSelectedOption(selectedOption);
      getValue(selectedOption.value);
    }
  };

  return (
    <AsyncSelect
      value={{
        label: posSaleData.customerName,
        option: posSaleData.customerId,
      }}
      loadOptions={fetchData}
      placeholder="Customer Select"
      key={fetchData}
      onChange={(e) => {
        onSearchChange(e);
      }}
      defaultOptions={{
        label: posSaleData.customerName,
        option: posSaleData.customerId,
      }}
      className="basic-single "
      classNamePrefix="select"
      isDisabled={false}
      isLoading={false}
      isClearable={false}
      isSearchable={true}
      innerRef={selectRef}
      ref={props.customerSelect}
    />
  );
};

export default SelectCustomer;
